import React from "react"
import { graphql } from "gatsby"

import EventList from "../components/eventList"

export default ({ data }) => (
	<EventList
		type="Trainings"
		meta={{
			title: "Trainings",
			description: "Check out the awesome Java trainings at Accento on Sep 25th 2019!",
			keywords: `Java trainings Karlsruhe`,
			path: "/trainings",
		}}
		snippetId="trainings-intro"
		events={data.trainings.edges}
	/>
)

export const query = graphql`
	query {
		trainings: allMarkdownRemark(filter: { fields: { collection: { eq: "trainings" } } }) {
			...AllEventEdges
		}
	}
`
